import { msalInstance } from "../msalInstance";
import { accessTokenScopes } from "../authConfig";


/**
 * Retrieves an access token for the signed-in user using MSAL's silent token acquisition.
 *
 * This function attempts to retrieve a valid access token from MSAL's internal cache.
 * If a valid token is found, it is returned immediately. Otherwise, MSAL will attempt
 * to silently acquire a new token using a refresh token (if available).
 *
 * @returns {Promise<string>} A promise that resolves to a valid access token.
 * @throws {Error} If no user is signed in or if token acquisition fails.
 *
 * @example
 * const token = await getAccessToken();
 * fetch("/api/data", {
 *   headers: { Authorization: `Bearer ${token}` }
 * });
 */

export async function getAccessToken(): Promise<string> {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
        throw new Error("No user signed in");
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            scopes: accessTokenScopes,
            account: accounts[0],
        });

        return response.accessToken;
    } catch (err) {
        console.error("Token acquisition failed:", err);
        throw err;
    }
}
